import { styled } from 'baseui'
import { HIDE_SCROLLBAR_STYLE } from '@/constants/responsive'

/** One horizontally scrolling line of fixed-size items, for phone-width pickers. */
const SwipeRow = styled('div', {
  // A grid of max-content columns: items keep their size instead of flex-shrinking.
  display: 'grid',
  gridAutoFlow: 'column',
  gridAutoColumns: 'max-content',
  alignItems: 'center',
  gap: '10px',
  width: 'calc(100% + 4px)',
  boxSizing: 'border-box',
  overflowX: 'auto',
  overflowY: 'hidden',
  overscrollBehaviorX: 'contain',
  // Room for selection rings, which would otherwise be clipped by the scroll box.
  padding: '4px 2px',
  margin: '-4px -2px',
  ...HIDE_SCROLLBAR_STYLE,
})

export default SwipeRow
